// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xIsAuthenticated } from "@guestsupply/App/Store/Selectors/GeneralSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

type HasUserRolesRredicate = "one-or-more" | "apply-all" | "none";

export const xHasRoles = (
    state: ApplicationState,
    roles: string[],
    predicate: HasUserRolesRredicate = "one-or-more",
) => {
    const isAuthenticated = xIsAuthenticated(state);
    if (!isAuthenticated) {
        return false;
    }

    const session = getSession(state);
    
    if (!session.userRoles){
        return false;
    }
    const userRoles = session.userRoles?.trim()?.split(",");

    if (predicate === "one-or-more") {
        return userRoles.some(role => roles.includes(role.trim()));
    }

    if (predicate === "apply-all") {
        return userRoles.every(role => roles.includes(role.trim()));
    }

    if (predicate === "none") {
        return userRoles.every(role => !roles.includes(role.trim()));
    }
};
